import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

import GlassPopup from '../common/interface/glassPopup';
import ToggleSection from '../common/interface/toggleSection';
import FieldInfo from '../common/inputs/fieldInfo';
import Label from '../common/inputs/label';
import ObjectPolynomialReportDetailsEditor from '../common/inputs/objectPolynomialReportDetailsEditor';
import FormulaEditorLink from '../common/inputs/formulaEditorLink';

const VersionDetailPopup = props => {
  const {
    handleShowPopup,
    versionData,
    dimensionsList,
    handleEditFormulaLink,
    handleEditTableLink,
    fullLoading,
    status,
    popupState
  } = props;
  return (
    <GlassPopup
      className="form_popup version_popup"
      title={(<FormattedMessage id="common.versions.popup.title"/>)}
      {...props}
    >
      {(status==200 && versionData) && (
        <div>
          <FieldInfo 
            label={(<FormattedMessage id="common.versions.columns.date"/>)}
            value={FormatTooling.defaultsTextFormatTypes(versionData.created_at,Constants.crudGenerator.dataTypes.DATETIME, true)}
          />
          <FieldInfo 
            label={(<FormattedMessage id="polynomialAdmin.fields.kpi"/>)}
            value={FormatTooling.defaultsTextFormatTypes(versionData.kpi,Constants.crudGenerator.dataTypes.BOOLEAN)}
          />
          {(versionData.sub_model_dimension_id) && (
            <FieldInfo 
              label={LocaleTooling.getCalculationUnitContextLocale((<FormattedMessage id="polynomialAdmin.fields.sub_model_dimension_id"/>))}
              value={(dimensionsList.find(item => item.id==versionData.sub_model_dimension_id)).name}
            />
          )}
          {(versionData.kpi) && (
            <FieldInfo 
              label={(<FormattedMessage id="polynomialAdmin.fields.goal"/>)}
              value={<FormulaEditorLink 
                data-path="goal_lineal_array"
                data-label={intl.formatMessage({id: "polynomialAdmin.fields.goal"})}                       
                data-disablemarkmode={"true"}
                value={versionData.goal}
                handleEditFormulaLink={handleEditFormulaLink}
                propsTarget={"polynomialVersion"}
                miniLayout={true}
                disabled={true}
              />}
            />
          )}
          <FieldInfo 
            label={(<FormattedMessage id="polynomialAdmin.fields.formula_type"/>)}
            value={(<FormattedMessage id={"polynomialAdmin.fields.selectValues.formula_type." + versionData.formula_type}/>)}
          />
          {(versionData.formula_type != Constants.selectKeys.polynomial.formulaType.TABLE) ? (
            <FieldInfo 
              label={(<FormattedMessage id="polynomialAdmin.fields.formula"/>)}
              value={<FormulaEditorLink 
                data-path="formula_lineal_array"
                data-label={intl.formatMessage({id: "polynomialAdmin.fields.formula"})}
                value={versionData.formula_lineal_array}
                handleEditFormulaLink={handleEditFormulaLink}
                propsTarget={"polynomialVersion"}
                miniLayout={true}
                disabled={true}
              />}
            />
          ) : (
            <FieldInfo 
              label={(<FormattedMessage id="polynomialAdmin.fields.formula_table"/>)}
              value={<FormulaEditorLink 
                data-path="formula_lineal_array"                
                value={versionData.formula_lineal_array}
                handleEditFormulaLink={handleEditTableLink}
                propsTarget={"polynomialVersion"}
                miniLayout={true}
                disabled={true}
              />}
            />
          )}
          <FieldInfo 
            label={(<FormattedMessage id="polynomialAdmin.fields.detail"/>)}
            value={<FormulaEditorLink 
                data-path="detail_lineal_array"
                data-label={intl.formatMessage({id: "polynomialAdmin.fields.detail"})}                     
                data-disablemarkmode={"true"}
                value={versionData.detail}
                handleEditFormulaLink={handleEditFormulaLink}
                propsTarget={"polynomialVersion"}
                miniLayout={true}
                disabled={true}
              />}
          />
          <ToggleSection
            title={<FormattedMessage id="polynomialAdmin.fields.reportsConfigTitle"/>}
          >
            <div>
              <FieldInfo
                label={(<FormattedMessage id="polynomialAdmin.fields.report_label"/>)}
                value={versionData.report_label}
              />
              <FieldInfo
                label={(<FormattedMessage id="polynomialAdmin.fields.report_rich_description"/>)}
                value={versionData.report_rich_description}
              />
              <FieldInfo
                label={(<FormattedMessage id="polynomialAdmin.fields.return_type_format"/>)}
                value={versionData.return_type_format}
              />
              <FieldInfo
                label={(<FormattedMessage id="polynomialAdmin.fields.detail_format"/>)}
                value={versionData.detail_format}
              />
              <FieldInfo
                label={(<FormattedMessage id="polynomialAdmin.fields.order"/>)}
                value={versionData.order}
              />
              {(versionData.formula_type != Constants.selectKeys.polynomial.formulaType.TABLE) && (
                <FieldInfo
                  label={(<FormattedMessage id="polynomialAdmin.fields.report_columns_number"/>)}
                  value={versionData.report_columns_number}
                />
              )}
              <FieldInfo 
                label={(<FormattedMessage id="polynomialAdmin.fields.display_report"/>)}
                value={FormatTooling.defaultsTextFormatTypes(versionData.display_report,Constants.crudGenerator.dataTypes.BOOLEAN)}
              />
              <FieldInfo 
                label={(<FormattedMessage id="polynomialAdmin.fields.display_report_formula"/>)}
                value={FormatTooling.defaultsTextFormatTypes(versionData.display_report_formula,Constants.crudGenerator.dataTypes.BOOLEAN)}
              />
              <FieldInfo 
                label={(<FormattedMessage id="polynomialAdmin.fields.stop_display_report"/>)}
                value={FormatTooling.defaultsTextFormatTypes(versionData.stop_display_report,Constants.crudGenerator.dataTypes.BOOLEAN)}
              />
              {(versionData.exclude_model_from_reports == true) && (
                <FieldInfo 
                  label={(<FormattedMessage id="polynomialAdmin.fields.exclude_model_from_reports"/>)}
                  value={FormatTooling.defaultsTextFormatTypes(versionData.exclude_model_from_reports,Constants.crudGenerator.dataTypes.BOOLEAN)}
                />
              )}
              {(versionData.hide_model_from_reports_if_zero == true) && (
                <FieldInfo 
                  label={(<FormattedMessage id="polynomialAdmin.fields.hide_model_from_reports_if_zero"/>)}
                  value={FormatTooling.defaultsTextFormatTypes(versionData.hide_model_from_reports_if_zero, Constants.crudGenerator.dataTypes.BOOLEAN)}
                />
              )}
              {(versionData.exclude_model_from_calculation_reports == true) && (
                <FieldInfo 
                  label={(<FormattedMessage id="polynomialAdmin.fields.exclude_model_from_calculation_reports"/>)}
                  value={FormatTooling.defaultsTextFormatTypes(versionData.exclude_model_from_calculation_reports,Constants.crudGenerator.dataTypes.BOOLEAN)}
                />
              )}
              {(versionData.new_page_for_model == true) && (
                <FieldInfo 
                  label={(<FormattedMessage id="polynomialAdmin.fields.new_page_for_model"/>)}
                  value={FormatTooling.defaultsTextFormatTypes(versionData.new_page_for_model,Constants.crudGenerator.dataTypes.BOOLEAN)}
                />
              )}
              <FieldInfo 
                label={(<FormattedMessage id="polynomialAdmin.fields.report_hide_total_block"/>)}
                value={FormatTooling.defaultsTextFormatTypes(versionData.report_hide_total_block,Constants.crudGenerator.dataTypes.BOOLEAN)}
              />
              <FieldInfo 
                label={(<FormattedMessage id="polynomialAdmin.fields.report_only_first_line_header"/>)}
                value={FormatTooling.defaultsTextFormatTypes(versionData.report_only_first_line_header,Constants.crudGenerator.dataTypes.BOOLEAN)}
              />
              {(versionData.formula_type != Constants.selectKeys.polynomial.formulaType.TABLE) && (
                <ObjectPolynomialReportDetailsEditor 
                  id="report_details"
                  data-path="report_details"
                  handleEditFormulaLink={handleEditFormulaLink}
                  disabled={true}
                  propsTarget={"polynomialVersion"}
                  values={versionData.report_details}
                />
              )}
            </div>
          </ToggleSection>
        </div>
      )}
    </GlassPopup>
  );
};

export default VersionDetailPopup;



// WEBPACK FOOTER //
// ./source/client/components/polynomialAdmin/versionDetailPopup.jsx